// extracted by mini-css-extract-plugin
export default {"watchCard":"WatchCard_watchCard__5Mnr+","name":"WatchCard_name__rbJcY"};